import type { IFilterView } from "@bbj-types/user";
import { useCallback } from "react";
import { axiosSettings } from "./axios";

export type TPostOrganisationFilterViewBody = Omit<IFilterView, "_id">;

export const usePostOrganisationFilterView = () => {
  const [state, execute, cancel] = axiosSettings<string, TPostOrganisationFilterViewBody, unknown>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: TPostOrganisationFilterViewBody) => {
      return execute({
        url: "/v2/organisations/filterView",
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
